import React, { Component } from 'react'
import Recaptcha from 'react-recaptcha'
import Modal from '../utils/modal'
import '../footer/footer'
import * as emailjs from "emailjs-com";
export default class Footer extends Component {
  constructor () {
    super()

    this.state = {
      modal: false,
      modalAction: '',
      okToSubmit: true,
      inputInfo: ''
    }
  }

  onChangeInputValue = (e) => {
    const inputInfo = e.target.name
    this.setState({inputInfo: e.target.name})
    let value = e.target.value
    value = this.clearWhiteSpace(value)

    if (inputInfo === 'formPhone') {
      value = this.onChangePhone(e)
    }

      this.setState({
        [inputInfo]: value
      })


  }

  clearWhiteSpace = (value) => {
    if (value == null) return value
    return value.replace(/^\s+/g, '')
  }

  onChangePhone = (e) => {
    let value
    value = e.target.value.replace(/\D/g, '')

    if (value.length === 10) {
      const str = `00000000${value}`
      value = str.substr(-10).replace(/\D/g, '').replace(/(\d{2})(\d{4})(\d{4})/g, '($1) $2-$3')
      return value
    }

    if (value.length >= 11) {
      const str = `00000000${value}`
      value = str.substr(-11).replace(/\D/g, '').replace(/(\d{2})(\d{5})(\d{4})/g, '($1) $2-$3')
      return value
    }
    return value
  }

//   submitForm = (e) => {
//     e.preventDefault()
//     const validatePhone = this.validatePhone()

//     if (validatePhone) {
//       const modalAction = 'tel'
//       const modal = true

//       return this.setState({modal, modalAction})
//     }

//     const {formName, formEmail, formPhone, formMsg, inputInfo} = this.state
//     const formContent = {
//       to_name: 'Hit-Bra',
//       from_name: formName,
//       reply_to: formEmail,
//       phone_number: formPhone,
//       message_html: formMsg,
//       form_tipo: 'CONTATO: HIT-BRA',
//       inputInfo: inputInfo
//     }
//     console.log(this.state)
//     const keys = ["B7F8908A957E3D6618245C667DF1B0E010C72FDC7478737E756DB0E8D178FA2E", "YWxlbcOjbyBmb2kgYSBlc29sYSBhcHJlbmRlciBhIGVzdHVkYXI=", "s(n[)[y=},q6DxCs5c54seGbbpKAfb>zpNt", "2DB2B674BF72654C33959F71E2A1465792A85DC776945C08A7B1912BBF45AA27", "anVhcmV6IG1hdGhldXMgd2lsbGlhbSByZW7Dqg==", ";;SNW!(7=RYDU6V^FNCCmq#5vFmqD;t8naSqX!9", "2CF24DBA5FB0A30E26E83B2AC5B9E29E1B161E5C1FA7425E73043362938B9824", "Ymx1bWVuYXUgY2FybGlzdG9zIHRldGV1IGNhcmxvcyBlZHVhcmRv", "_Y!NGjdq-Qg^UnyDr2~,'PSay64t;KhX[q&9*>", "579472CCD02915E5F56714328CAF2AD728848A4E4B4D43B471E9CA0BDD47E2AC", "Y2Ficml0byBuYSBzZXh0YSBmb2kgcGVzY2FyIG5hIGZhemVuZGluaGE=", "3=&HsW.F![XQm6Tr_f]bc>q}N(r)3Y`K>A:nx8t+", "7F5244143287B47563DEF1EBD45CE1C7C5D529F122ED6D5F9B77D8928F4DAE6C", "NDY1NDY0NDY1NDY1NjU0NTY2NTY0NTQ0NjU0NjQ2NjU5Nzg5Nzg=", "X#Tpsg>6W`(XH:94f#5XY?=&6#}^`t9k5ww-8b`"];
//     const random =  Math.floor((Math.random() * keys.length));
//     const config = { headers: {  
//       'Content-Type': 'application/json',
//       'key':keys[random],

//   }
// }

//     axios.post('http://107.180.9.111:50001/prod', formContent, config).then( 
//         (response) => {
//           var result = response.data
//               this.clearForm()
//               this.onSuccessFormSubmit()
//               console.log(result)
//               console.log(process.env)
              
//         }, (error) => {
//               this.onFailFormRequest()
//               console.log(error)
//               console.log(process.env)
//             })

// }

    // emailjs.send('<YOUR SERVICE ID>','<YOUR TEMPLATE ID>', '<YOUR PARAMS>', '<YOUR USER ID>')
  //   emailjs.send('smtp_server', 'template_contato', formContent, 'user_ydkNKT0G5WeDWqPZT6MkW')
  //     .then((response) => {
  //       this.clearForm()
  //       this.onSuccessFormSubmit()
  //     }, (error) => {
  //       this.onFailFormRequest()
  //     })
  // }

  validatePhone = () => {
    const number = this.state.formPhone === undefined ? '' : this.state.formPhone
    if (number.length <= 9) {
      return true
    }

    return false
  }

  onSuccessFormSubmit = () => {
    const modalAction = 'success'
    const modal = true

    this.setState({modal, modalAction})
  }

  onFailFormRequest = () => {
    const modalAction = 'fail'
    const modal = true

    this.setState({modal, modalAction})
  }

  openModal = () => {
    const name = this.state.modalAction
    let toRender
    switch(name) {
      case 'success':
        toRender = (
          <Modal closeModal={this.closeModal} customClass='success alignC'>
            <h2>Mensagem enviada com sucesso!</h2>
            <div className='alignC'>
              <a className='button success' onClick={this.closeModal}>Ok</a>
            </div>
          </Modal>
        )
        break
      case 'fail':
        toRender = (
          <Modal closeModal={this.closeModal} customClass='fail'>
            <h2>Não foi possível enviar sua mensagem, por favor, tente novamente.</h2>
            <div className='alignC'>
              <a className='button warning' onClick={this.closeModal}>Ok</a>
            </div>
          </Modal>
        )
        break
      case 'tel':
        toRender = (
          <Modal closeModal={this.closeModal}>
            <h2>Favor, preencher corretamente o número telefone.</h2>
            <div className='alignC'>
              <a className='button warning' onClick={this.closeModal}>Ok</a>
            </div>
          </Modal>
        )
        break
      default:
      this.setState({modal: false})
    }

    return toRender
  }

  closeModal = () => {
    this.setState({
      modal: false
    })
  }

  clearForm = () => {
    document.getElementById('form').reset()
    this.setState({
      formName: '',
      formEmail: '',
      formPhone: '',
      formMsg: ''
    })
  }

  verifyCallback = () => {
    this.setState({okToSubmit: true})
  }

  submitForm = (e) => {
    e.preventDefault();

    const {
      name,
      email,
      tel,
      msg,
    } = this.state;
    const formContent = {
      to_name: "Hit-Bra",
      name: name,
      email: email,
      tel: tel,
      msg: msg,
      
    };

    emailjs
      .send(
        "sendMessage",
        "template_xjsv3sj",
        formContent,
        "user_cz6Le3va9WTxaNDEplsbp"
      )
      .then(
        (response) => {
          alert("Contato enviado com sucesso!");
        },
        (error) => {
          alert("Erro ao enviar contato.")
        }
      );
  };

  render() {

    return (
      <section id='footerContact'>
        {this.state.modal ? this.openModal() : null }
        <div className='contactContent squad clear relative'>
          <div id="top-content">
            <div className='leftSide'>
              <div id="main-container">
                {/* <div className='markAddress'>
                  <i className="fas fa-map-marker-alt" />
                </div> */}
                <div className='markAddress'>
                  <div className='address-logo'>
                    <i className="fas fa-map-marker-alt" />
                  </div>
                  <div className="address-paragraph">
                    <p>R. Cap. Cassiano Ricardo de Toledo, 191 </p>
                    <p>Chácara Urbana - Jundiaí - São Paulo</p>
                    <p>CEP: 13201-840</p>
                    <p>5º andar – Sala 508 / 509</p><br/>
                  </div>
                </div>
                <div className="contactList">
                  <div className="contact-logo">
                    {/* <i className="fas fa-mobile-alt" /> */}
                    <i className="fab fa-whatsapp" />
                    <i className="far fa-envelope" />
                  </div>
                  <div className="contact-paragraph">
                    {/* <p>+55 (11) 4586-0120</p> */}
                    <p>+55 (11) 91016-0635</p>
                    <p><a href='mailto:info@hit-bra.com'>info@hit-bra.com</a></p>
                  </div>
                </div>
              </div>
              <iframe title='Map' src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7335.34376632067!2d-46.89250109314691!3d-23.182885735497358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cf268f48e73555%3A0xdba843adbb98fc9d!2sR.+Cap.+Cassiano+Ricardo+de+Toledo%2C+191+-+Ch%C3%A1cara+Urbana%2C+Jundia%C3%AD+-+SP%2C+13201-000!5e0!3m2!1spt-BR!2sbr!4v1554593720866!5m2!1spt-BR!2sbr' frameBorder='0' allowFullScreen></iframe>
            </div>
            <div className='rightSide'>
              <form
                id='form'
                autoComplete = 'off'
                action=''
                method='post'
                className='clear'
                onSubmit={this.submitForm}>
                <input
                  name='name'
                  type='text'
                  value={this.state.name}
                  id='Nome'
                  placeholder='Nome Completo'
                  required
                  onChange={(e) => this.onChangeInputValue(e)}
                  on
                />
                <input
                  name='email'
                  type='text'
                  value={this.state.email}
                  id='email'
                  placeholder='E-mail (ex. meunome@meudominio.com)'
                  pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$'
                  required
                  onChange={(e) => this.onChangeInputValue(e)}
                />
                <input
                  name='tel'
                  type='text'
                  value={this.state.tel}
                  id='fone'
                  placeholder='Telefone: ex. (xx) xxxxx-xxxx'
                  required
                  onChange={(e) => this.onChangeInputValue(e)}
                />
                <textarea
                  name='msg'
                  id='mensagem'
                  value={this.state.msg}
                  placeholder='Digite aqui a sua mensagem'
                  required
                  onChange={(e) => this.onChangeInputValue(e)}
                ></textarea>
                <div className='Captcha left'>
                  <Recaptcha
                  sitekey='6LfySZ0UAAAAAIhom-YhH7TGknnbY5INfQJNXIh5'
                  render='explicit'
                  verifyCallback={this.verifyCallback}
                  theme='dark'
                  />
                </div>
                <button
                  type='submit'
                  className='btn-send button'
                  name='Submit'
                  {...(this.state.okToSubmit ? {} : {disabled: true})}
                >
                  Enviar
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      )
  }
}




// WEBPACK FOOTER //
// ./src/components/footer/footer.js